import { Container, ZIndex } from '@optimus-web/core';
import { isDeprecatedDomainError } from '../services/error/selectors';
import { useAppSelector } from '../utils/redux';
import { Appbar, Navbar } from './common';

const TOOLBAR_Z_INDEX = ZIndex.High - 1;

export const Toolbar = () => {
    const shouldDisplayDeprecationError = useAppSelector(isDeprecatedDomainError);
    return (
        <Container position="absolute" width="100%" zIndex={TOOLBAR_Z_INDEX}>
            <Appbar id="toolbar" />
            {!shouldDisplayDeprecationError ? <Navbar id="navigation" /> : null}
        </Container>
    );
};
